import React, { useEffect, useState } from 'react';
import { Spinner } from '@myhealth-raccoon/components';
import { captureException } from '@sentry/react';
import { useNavigate, useParams } from 'react-router-dom';

import { authService } from 'src/services/auth';
import { bookingService } from 'src/services/booking';
import { umbracoService } from 'src/services/umbraco';
import { ManageBooking } from './ManageBooking';
import { useDispatch } from 'src/store';
import { setAppointmentFromHash, setClinicId } from 'src/store/appointment';
import { isRequestError } from 'src/utils/requestError';
import { isRaccoonError } from '@myhealth-raccoon/services';

async function getToken(code: string) {
    switch (authService.Token?.token_type) {
        default:
            {
                const umbracoToken = await umbracoService.GetBookingToken();
                authService.Token = { jwt: umbracoToken.access_token, token_type: "umbraco" };
                break;
            }
        case 'umbraco':
            await authService.ConnectManageBookingAppLite(code);
            break;
        case 'booking_manage_guest':
            await authService.BookingTempToken(code);
            break;
    }
}

export function VerifyShortcode() {

    const navigate = useNavigate();
    const { code, siteId } = useParams();

    const dispatch = useDispatch();

    const [appointmentId, setAppointmentId] = useState<number>();
    const [appointmentTypeName, setAppointmentTypeName] = useState<string>();
    const [isCancellable, setIsCancellable] = useState<boolean>();

    useEffect(() => {
        if (siteId) {
            dispatch(setClinicId(Number(siteId)))
        }
    }, [siteId, dispatch])

    useEffect(() => {
        (async () => {
            try {
                if (!siteId || !code) {
                    throw "Invalid URL";
                }

                while (authService.Token?.token_type !== 'booking_manage') {
                    await getToken(code);
                }

                const bookingByHash = await bookingService.GetBookingByHash(siteId, code);
                dispatch(setAppointmentFromHash(bookingByHash));
                setAppointmentId(bookingByHash.appointment_id);
                setAppointmentTypeName(bookingByHash.appointment_type_name);
                setIsCancellable(bookingByHash.can_be_cancelled);
            } catch (e) {
                captureException(e);
                if (isRequestError(e) && e.statusCode === 404) {
                    if (isRaccoonError(e.data) && e.data.messages.find(m => m.value.startsWith("This appointment is cancelled"))) {
                        navigate('/manage/cancelled', { replace: true });
                    } else {
                        navigate('/manage/not-found', { replace: true });
                    }
                } else {
                    navigate('/manage/error', { replace: true });
                }
            }
        })()
    }, [code, dispatch, navigate, siteId]);

    if (!appointmentId) {
        return <>
            <h1 className='text-gray-900 text-2xl font-semibold mb-2.5'>Verifying</h1>
            <Spinner className='mt-5' />
        </>
    }

    return <ManageBooking appointmentId={appointmentId} appointmentTypeName={appointmentTypeName!} isCancellable={isCancellable} />


}